// extracted by mini-css-extract-plugin
export var aircallIframe = "_dl-3";
export var fabContainer = "_dl-5";
export var fabRinging = "_dl-6";
export var loadingOverlay = "_dl-4";
export var pulse = "_dl-7";
export var widgetContent = "_dl-2";
export var widgetPanel = "_dl-0";
export var widgetPanelExpanded = "_dl-1";